/* Xtreme smart collection merchandising
   Mixes latest model, newly-added and fast-selling signals on the visible collection page.
   Sales signal uses Shopify's existing collection rank; tag a product "Xtreme Bestseller"
   or "Bestseller" to give it an additional bestseller boost.
*/
(function () {
  function modelScore(title) {
    var t = (title || '').toLowerCase();
    var scores = [];
    var patterns = [
      /iphone\s*(\d{2})/g,
      /galaxy\s*s\s*(\d{2})/g,
      /galaxy\s*a\s*(\d{2})/g,
      /pixel\s*(\d{1,2})/g,
      /redmi(?:\s*note)?\s*(\d{1,2})/g,
      /oneplus\s*(\d{1,2})/g
    ];
    patterns.forEach(function (re) {
      var m;
      while ((m = re.exec(t))) scores.push(parseInt(m[1], 10) || 0);
    });
    return scores.length ? Math.max.apply(Math, scores) : 0;
  }

  function smartSort(grid) {
    if (!grid || grid.dataset.xtremeSmartSorted === '1') return;
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList.contains('grid-product');
    });
    if (cards.length < 4) return;

    var now = Math.floor(Date.now() / 1000);
    var maxModel = Math.max.apply(Math, cards.map(function (el) { return modelScore(el.dataset.xtremeTitle); }));
    var n = cards.length;

    var groups = { latest: [], newItems: [], selling: [], rest: [] };
    cards.forEach(function (el, index) {
      var title = el.dataset.xtremeTitle || '';
      var tags = (el.dataset.xtremeTags || '').toLowerCase();
      var created = parseInt(el.dataset.xtremeCreated || '0', 10);
      var ageDays = created ? (now - created) / 86400 : 9999;
      var model = modelScore(title);
      var latest = maxModel > 0 && model >= maxModel - 1;
      var fresh = ageDays <= 45;
      var taggedBest = /(^|,\s*)(xtreme bestseller|bestseller|best seller)(\s*,|$)/i.test(tags);
      var salesRank = 1 - (index / Math.max(1, n - 1));
      var selling = taggedBest || index < Math.max(4, Math.ceil(n * 0.30));
      var score = (latest ? 100 : 0) + (fresh ? 70 : 0) + (taggedBest ? 95 : 0) + salesRank * 45;
      var item = { el: el, score: score };
      if (latest) groups.latest.push(item);
      else if (fresh) groups.newItems.push(item);
      else if (selling) groups.selling.push(item);
      else groups.rest.push(item);
    });
    Object.keys(groups).forEach(function (k) { groups[k].sort(function(a,b){ return b.score-a.score; }); });

    // Deliberate mix: latest model, fast seller, new item, fast seller, then repeat.
    var pattern = ['latest', 'selling', 'newItems', 'selling', 'latest', 'newItems'];
    var ordered = [], used = new Set();
    function take(group) {
      while (groups[group].length) {
        var x = groups[group].shift();
        if (!used.has(x.el)) { used.add(x.el); ordered.push(x.el); return true; }
      }
      return false;
    }
    while (ordered.length < cards.length) {
      var before = ordered.length;
      pattern.forEach(function (g) { if (ordered.length < cards.length) take(g); });
      if (ordered.length === before) break;
    }
    cards.forEach(function(el){ if (!used.has(el)) ordered.push(el); });
    ordered.forEach(function(el){ grid.appendChild(el); });
    grid.dataset.xtremeSmartSorted = '1';
  }

  function run() {
    document.querySelectorAll('.collection-grid__wrapper .grid.grid--uniform').forEach(smartSort);
  }
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('ajaxProduct:loaded', run);
  document.addEventListener('collection:reloaded', run);
  new MutationObserver(function(){ window.requestAnimationFrame(run); }).observe(document.documentElement, {childList:true, subtree:true});
})();
